var render = function render(){
  var _vm$filteredCities;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', {
    staticClass: "home__main"
  }, [_c('h1', {
    staticClass: "visually-hidden"
  }, [_vm._v("\n    CVing\n  ")]), _vm._v(" "), _c('section', {
    staticClass: "section img__section"
  }, [_c('booster-picture', _vm._b({
    attrs: {
      "critical": ""
    }
  }, 'booster-picture', _vm.picture, false)), _vm._v(" "), _c('div', {
    staticClass: "text__section"
  }, [_c('div', {
    staticClass: "text__section-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('home.findYouNewJob')) + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "text__section-subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$tc('home.new_jobs_posted_this_week', _vm.countPublishedCampaigns))
    },
    on: {
      "click": function ($event) {
        return _vm.searchCampaigns();
      }
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "text__section-form"
  }, [_c('span', {
    staticClass: "homepage-input p-input-icon-left p-full"
  }, [_c('i', {
    staticClass: "pi pi-user"
  }), _vm._v(" "), _c('InputText', {
    staticClass: "p-inputtext-rounded p-full",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholderWhat
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.searchCampaigns();
      }
    },
    model: {
      value: _vm.search.text,
      callback: function ($$v) {
        _vm.$set(_vm.search, "text", $$v);
      },
      expression: "search.text"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "homepage-input p-input-icon-left p-full",
    class: {
      'multiselect--loading': _vm.isLoadingPlaces && ((_vm$filteredCities = _vm.filteredCities) === null || _vm$filteredCities === void 0 ? void 0 : _vm$filteredCities.length) === 0
    }
  }, [_c('i', {
    staticClass: "pi pi-map-marker"
  }), _vm._v(" "), _c('multiselect', {
    ref: "multiselectLocationHome",
    attrs: {
      "id": "multiselectLocationHome",
      "aria-label": _vm.$t('radar.city'),
      "placeholder": _vm.placeholderCity,
      "label": "formatted_locality",
      "track-by": "place_id",
      "open-direction": "bottom",
      "options": _vm.filteredCities,
      "internal-search": false,
      "clear-on-select": true,
      "clear-on-blur": true,
      "close-on-select": true,
      "options-limit": 5,
      "show-no-results": true,
      "show-no-options": true,
      "loading": _vm.isLoadingPlaces,
      "select-label": '',
      "deselect-label": ''
    },
    on: {
      "search-change": _vm.update,
      "select": _vm.addSelectedPlaces,
      "open": function ($event) {
        _vm.loadPlaces().catch(function () {});
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function (_ref) {
        var option = _ref.option;
        return [_c('span', [_vm._v(_vm._s(option.formatted_locality_complete))])];
      }
    }, {
      key: "clear",
      fn: function () {
        var _vm$search$city;
        return [_vm.search.city && ((_vm$search$city = _vm.search.city) === null || _vm$search$city === void 0 ? void 0 : _vm$search$city.formatted_locality) !== '' ? _c('div', {
          staticClass: "multiselect__clear",
          on: {
            "click": function ($event) {
              $event.preventDefault();
              $event.stopPropagation();
              return function () {
                _vm.search.city = null;
              }.apply(null, arguments);
            }
          }
        }, [_c('i', {
          staticClass: "pi pi-times"
        })]) : _vm._e()];
      },
      proxy: true
    }, {
      key: "noResult",
      fn: function () {
        return [_c('span', [_vm._v(_vm._s(_vm.$t("radar.noResults")))])];
      },
      proxy: true
    }, {
      key: "noOptions",
      fn: function () {
        return [_c('span', [_vm._v(_vm._s(_vm.$t("radar.startToDigit")))])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.search.city,
      callback: function ($$v) {
        _vm.$set(_vm.search, "city", $$v);
      },
      expression: "search.city"
    }
  })], 1), _vm._v(" "), _c('Button', {
    staticClass: "homepage-btn p-button-rounded uppercase",
    attrs: {
      "label": _vm.$t('home.search')
    },
    on: {
      "click": function ($event) {
        return _vm.searchCampaigns();
      },
      "tap": function ($event) {
        return _vm.searchCampaigns();
      }
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text__section-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.doLogin'))
    }
  })])], 1), _vm._v(" "), _vm.opportunities && _vm.opportunities.length > 0 ? _c('section', {
    staticClass: "section"
  }, [_c('header', {
    staticClass: "section__header padding-no-scroll"
  }, [_c('span', {
    staticClass: "section-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('home.featuredOpportunities')) + "\n      ")]), _vm._v(" "), _c('nuxt-link', {
    staticClass: "home-link",
    attrs: {
      "to": _vm.localePath({
        name: 'radar',
        query: {
          p: '1',
          ea: '0',
          verified: 'true',
          orp: 'false',
          order: '1'
        }
      })
    }
  }, [_c('span', {
    staticClass: "link-text-mobile"
  }, [_vm._v(_vm._s(_vm.$t('home.viewAll')))]), _vm._v(" "), _c('span', {
    staticClass: "link-text-desktop"
  }, [_vm._v(_vm._s(_vm.$t('home.viewAllJobsDesktop')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-with-scroll",
    attrs: {
      "aria-roledescription": "carousel-opportunità",
      "aria-live": "polite",
      "aria-label": "Carosello opportunità"
    }
  }, [_c('ssr-carousel', {
    key: _vm.opportunities.length,
    attrs: {
      "loop": "",
      "show-dots": "",
      "paginate-by-slide": true,
      "responsive": _vm.settings,
      "aria-label": "Carosello opportunità"
    }
  }, _vm._l(_vm.opportunities, function (opportunity, index) {
    return _c('Opportunity', {
      key: 'opportunity__' + opportunity.cid + '_' + index,
      attrs: {
        "opportunity": opportunity,
        "index": 'opportunity-' + index,
        "from-radar": false
      }
    });
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), _vm.companies && _vm.companies.length > 0 ? _c('section', {
    staticClass: "section"
  }, [_c('header', {
    staticClass: "section__header padding-no-scroll"
  }, [_c('span', {
    staticClass: "section-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('home.suggestedCompanies')) + "\n      ")]), _vm._v(" "), _vm.companies.length > 0 ? _c('nuxt-link', {
    staticClass: "home-link",
    attrs: {
      "to": _vm.localePath({
        name: 'all-wp',
        params: {
          wp: 'companies'
        }
      })
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('home.seeMore')) + "\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-with-scroll",
    attrs: {
      "aria-roledescription": "carousel-aziende",
      "aria-live": "polite",
      "aria-label": "Carosello aziende"
    }
  }, [_c('ssr-carousel', {
    key: _vm.companies.length,
    attrs: {
      "loop": "",
      "show-dots": "",
      "paginate-by-slide": true,
      "responsive": _vm.settings,
      "aria-label": "Carosello aziende"
    }
  }, _vm._l(_vm.companies, function (company, index) {
    return _c('Company', {
      key: 'company__' + company.coid,
      attrs: {
        "company": company,
        "index": index
      }
    });
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), _vm.launchBoxes && _vm.launchBoxes.length > 0 ? _c('section', {
    staticClass: "section padding-with-scroll",
    attrs: {
      "role": "region",
      "aria-roledescription": "carousel-box",
      "aria-live": "polite",
      "aria-label": "Carosello dei box"
    }
  }, [_c('ssr-carousel', {
    key: _vm.launchBoxes.length,
    attrs: {
      "critical": true,
      "show-dots": "",
      "responsive": _vm.settings,
      "loop": "",
      "autoplay-delay": _vm.launchBoxes[0].slideDurationSeconds,
      "paginate-by-slide": true,
      "aria-label": "Carosello dei box"
    }
  }, _vm._l(_vm.launchBoxes, function (box, index) {
    return _c('LaunchBox', {
      key: 'box__' + box.id,
      attrs: {
        "box": box,
        "index": index
      }
    });
  }), 1)], 1) : _vm._e(), _vm._v(" "), _vm.banners && _vm.banners.length > 0 ? _c('section', {
    staticClass: "section section-banner padding-with-scroll",
    attrs: {
      "role": "region",
      "aria-roledescription": "carousel-banner",
      "aria-live": "polite",
      "aria-label": "Carosello dei banner"
    }
  }, [_c('ssr-carousel', {
    key: _vm.banners.length,
    attrs: {
      "show-dots": "",
      "slides-per-page": 1,
      "paginate-by-slide": true,
      "responsive": _vm.settingsBanner,
      "aria-label": "Carosello dei banner",
      "loop": "",
      "autoplay-delay": _vm.banners[0].slideDurationSeconds
    }
  }, _vm._l(_vm.banners, function (banner, index) {
    return _c('Banner', {
      key: 'banner__' + banner.id + '_' + index,
      attrs: {
        "banner": banner
      }
    });
  }), 1)], 1) : _vm._e(), _vm._v(" "), _vm.posts && _vm.posts.length > 0 ? _c('section', {
    staticClass: "section"
  }, [_c('header', {
    staticClass: "section__header padding-no-scroll"
  }, [_c('span', {
    staticClass: "section-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('home.ourSocials')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "padding-with-scroll",
    attrs: {
      "aria-roledescription": "carousel-socials",
      "aria-live": "polite",
      "aria-label": "Carosello socials"
    }
  }, [_c('ssr-carousel', {
    attrs: {
      "loop": "",
      "show-dots": "",
      "paginate-by-slide": true,
      "responsive": _vm.settings,
      "aria-label": "Carosello socials"
    }
  }, _vm._l(_vm.posts, function (post) {
    return _c('Social', {
      key: 'social__' + post.id,
      attrs: {
        "social": post
      }
    });
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "socials-list padding-no-scroll"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/CVingapp/",
      "target": "_blank",
      "aria-label": "Facebook Link"
    }
  }, [_c('svg', {
    attrs: {
      "width": "28",
      "height": "27",
      "viewBox": "0 0 28 27",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "facebook"
    }
  }, [_c('path', {
    attrs: {
      "id": "Vector",
      "d": "M27.3334 13.2303C27.3021 10.6895 26.5455 8.21044 25.1525 6.0852C23.7596 3.95996 21.7883 2.27702 19.471 1.23457C17.1536 0.192121 14.5866 -0.166421 12.0722 0.20117C9.55792 0.568761 7.20099 1.64718 5.27903 3.30941C3.35707 4.97165 1.95012 7.14848 1.22388 9.58354C0.49764 12.0186 0.482348 14.6105 1.17981 17.0539C1.87727 19.4974 3.25844 21.6907 5.16065 23.3755C7.06286 25.0603 9.4069 26.1664 11.9167 26.5637V17.1137H8.58338V13.2303H11.9167V10.2803C11.8396 9.59438 11.9139 8.89987 12.1346 8.24581C12.3552 7.59174 12.7167 6.99407 13.1935 6.49498C13.6703 5.99589 14.2509 5.60754 14.8942 5.35734C15.5376 5.10715 16.228 5.00121 16.9167 5.04699C17.9165 5.06069 18.9137 5.14983 19.9 5.31366V8.647H18.2334C17.946 8.61075 17.6541 8.63955 17.3794 8.73127C17.1046 8.82298 16.8539 8.97527 16.6459 9.17687C16.4379 9.37848 16.2779 9.62424 16.1776 9.89601C16.0774 10.1678 16.0395 10.4586 16.0667 10.747V13.2637H19.7667L19.1667 17.147H16.0834V26.4803C19.2332 25.9821 22.1002 24.3714 24.1642 21.9405C26.2282 19.5095 27.3526 16.4193 27.3334 13.2303Z",
      "fill": "var(--facebook)"
    }
  })])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/cving_app/",
      "target": "_blank",
      "aria-label": "Instagram Link"
    }
  }, [_c('svg', {
    attrs: {
      "width": "28",
      "height": "28",
      "viewBox": "0 0 28 28",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "instagram"
    }
  }, [_c('path', {
    attrs: {
      "id": "Vector",
      "d": "M14 7.31362C12.6485 7.31362 11.3273 7.71439 10.2036 8.46525C9.07985 9.21611 8.20401 10.2833 7.68681 11.532C7.16961 12.7806 7.03429 14.1545 7.29795 15.4801C7.56162 16.8056 8.21243 18.0232 9.16809 18.9789C10.1237 19.9345 11.3413 20.5853 12.6669 20.849C13.9924 21.1127 15.3664 20.9773 16.615 20.4601C17.8636 19.9429 18.9308 19.0671 19.6817 17.9434C20.4325 16.8196 20.8333 15.4985 20.8333 14.147C20.8355 13.249 20.6603 12.3594 20.3176 11.5294C19.975 10.6993 19.4718 9.94513 18.8368 9.31016C18.2018 8.67519 17.4476 8.17193 16.6176 7.8293C15.7875 7.48668 14.898 7.31143 14 7.31362ZM14 18.597C13.1199 18.597 12.2595 18.336 11.5277 17.847C10.7959 17.358 10.2255 16.663 9.88872 15.8499C9.55191 15.0368 9.46379 14.142 9.63549 13.2788C9.80719 12.4156 10.231 11.6227 10.8534 11.0003C11.4757 10.378 12.2686 9.95417 13.1318 9.78246C13.995 9.61076 14.8898 9.69888 15.7029 10.0357C16.5161 10.3725 17.2111 10.9429 17.7 11.6747C18.189 12.4065 18.45 13.2668 18.45 14.147C18.45 15.3272 17.9811 16.459 17.1466 17.2936C16.3121 18.1281 15.1802 18.597 14 18.597ZM22.7167 7.03029C22.7167 7.35993 22.6189 7.68216 22.4358 7.95624C22.2526 8.23032 21.9923 8.44394 21.6878 8.57009C21.3832 8.69624 21.0481 8.72924 20.7248 8.66493C20.4015 8.60062 20.1046 8.44189 19.8715 8.2088C19.6384 7.97572 19.4797 7.67874 19.4153 7.35544C19.351 7.03214 19.384 6.69703 19.5102 6.39249C19.6363 6.08794 19.85 5.82764 20.124 5.64451C20.3981 5.46137 20.7203 5.36362 21.05 5.36362C21.492 5.36362 21.9159 5.53922 22.2285 5.85178C22.5411 6.16434 22.7167 6.58826 22.7167 7.03029ZM27.2333 8.69696C27.2818 6.625 26.5089 4.61795 25.0833 3.11362C23.587 1.66977 21.579 0.878551 19.5 0.913623C17.3333 0.813623 10.6667 0.813623 8.49998 0.913623C6.42866 0.868772 4.42294 1.64112 2.91665 3.06362C1.49104 4.56795 0.718174 6.575 0.76665 8.64696C0.66665 10.8136 0.66665 17.4803 0.76665 19.647C0.718174 21.7189 1.49104 23.726 2.91665 25.2303C4.42294 26.6528 6.42866 27.4251 8.49998 27.3803C10.7 27.5136 17.3 27.5136 19.5 27.3803C21.5719 27.4288 23.579 26.6559 25.0833 25.2303C26.5089 23.726 27.2818 21.7189 27.2333 19.647C27.3333 17.4803 27.3333 10.8136 27.2333 8.64696V8.69696ZM24.4 22.0303C24.1737 22.6035 23.8321 23.1242 23.3963 23.5599C22.9605 23.9957 22.4399 24.3373 21.8666 24.5636C19.2793 25.0867 16.6343 25.266 14 25.097C11.3712 25.2663 8.73166 25.087 6.14998 24.5636C5.57675 24.3373 5.05611 23.9957 4.62034 23.5599C4.18456 23.1242 3.84294 22.6035 3.61665 22.0303C2.91665 20.2636 3.06665 16.097 3.06665 14.1636C3.06665 12.2303 2.91665 8.04696 3.61665 6.29696C3.83656 5.71807 4.17573 5.19189 4.61217 4.75258C5.04861 4.31328 5.57255 3.97065 6.14998 3.74696C8.73166 3.22359 11.3712 3.04425 14 3.21362C16.6343 3.04453 19.2793 3.22386 21.8666 3.74696C22.4399 3.97325 22.9605 4.31487 23.3963 4.75064C23.8321 5.18642 24.1737 5.70706 24.4 6.28029C25.1 8.04696 24.9333 12.2136 24.9333 14.147C24.9333 16.0803 25.1 20.2636 24.4 22.0136V22.0303Z",
      "fill": "url(#paint0_linear_3662_1368)"
    }
  })]), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "paint0_linear_3662_1368",
      "x1": "14",
      "y1": "-9.68897",
      "x2": "1",
      "y2": "32.311",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "var(--instagram1)"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "var(--instagram2)"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.linkedin.com/company/cving",
      "target": "_blank",
      "aria-label": "Linkedin Link"
    }
  }, [_c('svg', {
    attrs: {
      "width": "28",
      "height": "28",
      "viewBox": "0 0 28 28",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "linkedin"
    }
  }, [_c('path', {
    attrs: {
      "id": "Vector",
      "d": "M25.2 0.813611H2.94996C2.66317 0.800174 2.37654 0.843432 2.10649 0.94091C1.83644 1.03839 1.58827 1.18817 1.37618 1.38168C1.16409 1.57519 0.99225 1.80864 0.870495 2.06865C0.74874 2.32866 0.679461 2.61013 0.666626 2.89694V25.1969C0.683426 25.7972 0.929384 26.3683 1.354 26.7929C1.77863 27.2175 2.34969 27.4635 2.94996 27.4803H25.2C25.7835 27.4543 26.3337 27.2007 26.7325 26.7738C27.1313 26.347 27.3469 25.7809 27.3333 25.1969V2.89694C27.3381 2.61778 27.2858 2.34059 27.1796 2.08236C27.0734 1.82414 26.9156 1.59032 26.7159 1.39525C26.5161 1.20018 26.2786 1.04797 26.018 0.947953C25.7573 0.847936 25.4789 0.80222 25.2 0.813611ZM8.99996 23.0469H5.11663V11.1636H8.99996V23.0469ZM7.14996 9.36361C6.87897 9.37305 6.60896 9.32636 6.35689 9.22646C6.10481 9.12655 5.87612 8.97561 5.68517 8.78309C5.49422 8.59058 5.34514 8.36066 5.2473 8.10778C5.14946 7.8549 5.10497 7.58451 5.11663 7.31361C5.10464 7.03978 5.15003 6.76648 5.24988 6.51122C5.34972 6.25597 5.50182 6.0244 5.69641 5.83137C5.891 5.63835 6.12379 5.48813 6.37985 5.39036C6.63591 5.29258 6.90957 5.24941 7.18329 5.26361C7.45428 5.25417 7.72429 5.30086 7.97637 5.40077C8.22844 5.50067 8.45714 5.65162 8.64808 5.84413C8.83903 6.03664 8.98811 6.26656 9.08595 6.51944C9.18379 6.77233 9.22828 7.04271 9.21663 7.31361C9.22861 7.58744 9.18322 7.86074 9.08337 8.116C8.98353 8.37126 8.83143 8.60282 8.63684 8.79585C8.44225 8.98887 8.20946 9.13909 7.9534 9.23686C7.69735 9.33464 7.42368 9.37781 7.14996 9.36361ZM22.9 23.0469H19V16.5469C19 14.9969 18.45 13.9303 17.0666 13.9303C16.6369 13.934 16.2188 14.0706 15.8697 14.3212C15.5206 14.5718 15.2576 14.9243 15.1166 15.3303C15.0083 15.6346 14.9629 15.9578 14.9833 16.2803V23.0469H11.15V11.1636H14.9833V12.8303C15.3241 12.2042 15.8314 11.6845 16.449 11.3286C17.0667 10.9727 17.7707 10.7945 18.4833 10.8136C21 10.8136 22.9 12.4803 22.9 16.0303V23.0469Z",
      "fill": "var(--linkedin)"
    }
  })])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://t.me/digitaltalentweek",
      "target": "_blank",
      "aria-label": "Telegram Link"
    }
  }, [_c('svg', {
    attrs: {
      "width": "28",
      "height": "28",
      "viewBox": "0 0 28 28",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "telegram"
    }
  }, [_c('path', {
    attrs: {
      "id": "Vector",
      "d": "M14 0.81366C11.3629 0.81366 8.78502 1.59565 6.59236 3.06073C4.39971 4.52582 2.69074 6.6082 1.68157 9.04455C0.672403 11.4809 0.408359 14.1618 0.922828 16.7482C1.4373 19.3346 2.70717 21.7104 4.57188 23.5751C6.43658 25.4398 8.81235 26.7097 11.3988 27.2241C13.9852 27.7386 16.6661 27.4746 19.1024 26.4654C21.5388 25.4562 23.6211 23.7473 25.0862 21.5546C26.5513 19.3619 27.3333 16.7841 27.3333 14.147C27.3333 10.6108 25.9285 7.21939 23.4281 4.7189C20.9276 2.21842 17.5362 0.81366 14 0.81366ZM20.55 9.94699L18.3666 20.2637C18.2 20.997 17.7666 21.1637 17.15 20.8303L13.8166 18.3637L12.15 19.9137C12.0715 20.0162 11.9706 20.0995 11.8551 20.1573C11.7396 20.2151 11.6124 20.2457 11.4833 20.247L11.7166 16.9137L17.8833 11.3303C18.1666 11.097 17.8833 10.9637 17.4833 11.197L9.91663 15.947L6.5833 14.9137C5.86663 14.697 5.84997 14.197 6.7333 13.8637L19.5833 8.86366C20.2166 8.68033 20.75 9.04699 20.55 9.94699Z",
      "fill": "var(--telegram)"
    }
  })])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.tiktok.com/@cving_app",
      "target": "_blank",
      "aria-label": "TikTok Link"
    }
  }, [_c('svg', {
    attrs: {
      "width": "28",
      "height": "28",
      "viewBox": "0 0 28 28",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M28 14.0004C28 21.0711 22.7583 26.9165 15.9493 27.8654C15.3124 27.954 14.6611 28 14 28C13.2366 28 12.4876 27.9387 11.7572 27.821C5.09179 26.748 0 20.968 0 13.9996C0 6.26781 6.268 0 14 0C21.732 0 28 6.26781 28 13.9996V14.0004Z",
      "fill": "var(--tiktok)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21.1846 11.0854V13.7602C20.7162 13.7151 20.1099 13.6086 19.4368 13.362C18.5589 13.0403 17.9051 12.6002 17.4778 12.2591V17.6668L17.4673 17.6499C17.4746 17.7571 17.4778 17.8659 17.4778 17.9764C17.4778 20.6625 15.293 22.8479 12.6061 22.8479C9.9191 22.8479 7.73438 20.6616 7.73438 17.9764C7.73438 15.2911 9.9191 13.104 12.6061 13.104C12.8689 13.104 13.1269 13.125 13.3792 13.1653V15.8022C13.1365 15.7151 12.8769 15.6684 12.6061 15.6684C11.3339 15.6684 10.298 16.7035 10.298 17.9764C10.298 19.2493 11.3339 20.2844 12.6061 20.2844C13.8782 20.2844 14.9141 19.2485 14.9141 17.9764C14.9141 17.9288 14.9133 17.8812 14.9101 17.8337V7.32471H17.5842C17.5939 7.55124 17.6035 7.77938 17.6124 8.0059C17.6301 8.4517 17.789 8.87977 18.0655 9.23045C18.3904 9.64239 18.8692 10.1212 19.5432 10.5034C20.1736 10.8605 20.7654 11.0136 21.1846 11.0862V11.0854Z",
      "fill": "var(--tiktok1)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.2656 8.91364V11.5884C19.7972 11.5433 19.191 11.4369 18.5178 11.1902C17.6399 10.8686 16.9861 10.4284 16.5588 10.0874V15.4951L16.5484 15.4781C16.5556 15.5853 16.5588 15.6942 16.5588 15.8046C16.5588 18.4907 14.3741 20.6762 11.6871 20.6762C9.00015 20.6762 6.81543 18.4899 6.81543 15.8046C6.81543 13.1193 9.00015 10.9322 11.6871 10.9322C11.9499 10.9322 12.2079 10.9532 12.4603 10.9935V13.6304C12.2176 13.5434 11.958 13.4966 11.6871 13.4966C10.415 13.4966 9.37905 14.5317 9.37905 15.8046C9.37905 17.0775 10.415 18.1126 11.6871 18.1126C12.9593 18.1126 13.9952 17.0767 13.9952 15.8046C13.9952 15.757 13.9944 15.7095 13.9912 15.6619V5.15295H16.6652C16.6749 5.37948 16.6846 5.60762 16.6935 5.83415C16.7112 6.27995 16.87 6.70802 17.1465 7.05869C17.4714 7.47063 17.9503 7.94949 18.6243 8.3316C19.2547 8.68873 19.8464 8.8419 20.2656 8.91445V8.91364Z",
      "fill": "var(--tiktok2)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.8508 10.0825V12.7573C20.3824 12.7121 19.7762 12.6057 19.103 12.359C18.2251 12.0374 17.5713 11.5972 17.144 11.2562V16.6639L17.1336 16.6469C17.1408 16.7542 17.144 16.863 17.144 16.9734C17.144 19.6595 14.9593 21.845 12.2723 21.845C9.58536 21.845 7.40063 19.6587 7.40063 16.9734C7.40063 14.2881 9.58536 12.1011 12.2723 12.1011C12.5351 12.1011 12.7931 12.122 13.0455 12.1623V14.7992C12.8028 14.7122 12.5432 14.6654 12.2723 14.6654C11.0002 14.6654 9.96426 15.7005 9.96426 16.9734C9.96426 18.2463 11.0002 19.2814 12.2723 19.2814C13.5445 19.2814 14.5804 18.2455 14.5804 16.9734C14.5804 16.9259 14.5796 16.8783 14.5764 16.8307V6.32178H17.2505C17.2601 6.54831 17.2698 6.77645 17.2787 7.00297C17.2964 7.44878 17.4552 7.87684 17.7317 8.22752C18.0566 8.63946 18.5355 9.11831 19.2095 9.50043C19.8399 9.85755 20.4316 10.0107 20.8508 10.0833V10.0825Z",
      "fill": "var(--tiktok3)"
    }
  })])])])]) : _vm._e(), _vm._v(" "), _vm.events && _vm.events.length > 0 ? _c('section', {
    staticClass: "section"
  }, [_c('header', {
    staticClass: "section__header padding-no-scroll"
  }, [_c('span', {
    staticClass: "section-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("home.events")) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "padding-with-scroll",
    attrs: {
      "aria-roledescription": "carousel-eventi",
      "aria-live": "polite",
      "aria-label": "Carosello eventi"
    }
  }, [_c('ssr-carousel', {
    key: _vm.events.length,
    attrs: {
      "loop": "",
      "show-dots": "",
      "paginate-by-slide": true,
      "responsive": _vm.settings,
      "aria-label": "Carosello eventi"
    }
  }, _vm._l(_vm.events, function (event) {
    return _c('Event', {
      key: 'event__' + event.id,
      attrs: {
        "event": event
      }
    });
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), _vm.news && _vm.news.length > 0 ? _c('section', {
    staticClass: "section"
  }, [_c('header', {
    staticClass: "section__header padding-no-scroll"
  }, [_c('span', {
    staticClass: "section-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("home.lastArticles")) + "\n      ")]), _vm._v(" "), _c('Button', {
    staticClass: "section-button home-link",
    attrs: {
      "label": _vm.$t('home.seeMore')
    },
    on: {
      "click": function ($event) {
        return _vm.openLink('https://media.cving.com/', '_blank');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-with-scroll",
    attrs: {
      "aria-roledescription": "carousel-news",
      "aria-live": "polite",
      "aria-label": "Carosello articoli"
    }
  }, [_c('ssr-carousel', {
    key: _vm.news.length,
    attrs: {
      "loop": "",
      "show-dots": "",
      "paginate-by-slide": true,
      "responsive": _vm.settings,
      "aria-label": "Carosello articoli"
    }
  }, _vm._l(_vm.news, function (newsRes, index) {
    return _c('News', {
      key: 'news__' + index,
      attrs: {
        "news": newsRes
      }
    });
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "section section-language padding-no-scroll"
  }, [_c('Button', {
    ref: "languageButton",
    staticClass: "language-button",
    attrs: {
      "type": "button",
      "aria-expanded": _vm.toggleLanguageOpen
    },
    on: {
      "click": _vm.toggleLanguage
    }
  }, [_c('span', {
    staticClass: "language-button-main"
  }, [_c('booster-picture', {
    attrs: {
      "sources": [{
        src: _vm.flags[_vm.$i18n.locale],
        sizes: {
          xxs: '300px',
          xs: '30px',
          sm: '30px',
          md: '30px',
          lg: '30px',
          xl: '30px',
          xxl: '30px',
          '4k': '30px'
        }
      }],
      "title": 'flag__' + _vm.$i18n.locale,
      "alt": 'flag__' + _vm.$i18n.locale
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("home.chooseLanguage")))])], 1), _vm._v(" "), _c('i', {
    staticClass: "pi pi-angle-right"
  })]), _vm._v(" "), _c('OverlayPanel', {
    ref: "op"
  }, _vm._l(_vm.getLangs, function (locale) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.$i18n.locale !== locale.code,
        expression: "$i18n.locale !== locale.code "
      }],
      key: locale.code,
      staticClass: "flag",
      class: {
        'hidden-flag': _vm.$i18n.locale === locale.code
      },
      attrs: {
        "to": _vm.switchLocalePath(locale.code)
      },
      on: {
        "click": function ($event) {
          return _vm.changeLanguage(locale.code);
        }
      }
    }, [_c('span', [_c('span', {
      staticClass: "code"
    }, [_vm._v(" " + _vm._s(locale["name"]))])])]);
  }), 0)], 1), _vm._v(" "), _c('section', {
    staticClass: "menu-newsletter-container padding-no-scroll"
  }, [_c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section-panel-menu"
  }, [_c('div', {
    staticClass: "menu-container"
  }, _vm._l(_vm.items, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "menu-item"
    }, [_c('button', {
      staticClass: "menu-title",
      attrs: {
        "aria-expanded": _vm.activeIndex === index ? 'true' : 'false',
        "aria-controls": 'menu-content-' + index
      },
      on: {
        "click": function ($event) {
          return _vm.toggleMenu(index);
        }
      }
    }, [_c('span', {
      attrs: {
        "id": 'menu-title-' + index
      }
    }, [_c('i', {
      class: item.class
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.label))])]), _vm._v(" "), _c('i', {
      staticClass: "pi pi-angle-right"
    })]), _vm._v(" "), _c('div', {
      staticClass: "menu-content",
      class: {
        'expand': _vm.activeIndex === index
      },
      attrs: {
        "id": 'menu-content-' + index,
        "role": "menu",
        "aria-labelledby": 'menu-title-' + index
      }
    }, _vm._l(item.items, function (subItem, subIndex) {
      return _c('div', {
        key: 'menu-content-' + subIndex,
        staticClass: "menuitem-link",
        attrs: {
          "role": "menuitem",
          "target": "_blank",
          "rel": "noopener noreferrer"
        },
        on: {
          "click": function ($event) {
            return _vm.openLink(subItem.url, subItem.target);
          }
        }
      }, [_vm._v("\n              " + _vm._s(subItem.label) + "\n            ")]);
    }), 0)]);
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "section-newsletter"
  }, [_c('Newsletter')], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }